import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-historial',
  templateUrl: './admin-historial.component.html',
  styleUrls: ['./admin-historial.component.scss']
})
export class AdminHistorialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
